import * as React from 'react';

/** Bright palette similar to Copilot's status dot (cycles every second). */
const DOT_COLORS = ['#0078d4', '#8764b8', '#e3008c', '#ff8c00', '#00b294'] as const;
const COLOR_CYCLE_MS = 1000;

/** Copilot-style inline status: color-changing dot + label on a single row. */
export const LoadingDots: React.FC = () => {
  const [colorIndex, setColorIndex] = React.useState(0);

  React.useEffect(() => {
    const id = window.setInterval(() => {
      setColorIndex((i) => (i + 1) % DOT_COLORS.length);
    }, COLOR_CYCLE_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <span className="inline-flex w-fit max-w-full shrink-0 flex-nowrap items-center gap-2 text-sm text-muted-foreground">
      <span
        className="size-2.5 shrink-0 rounded-full"
        style={{
          backgroundColor: DOT_COLORS[colorIndex],
          transition: 'background-color 0.45s ease-in-out',
        }}
        aria-hidden
      />
      <span className="whitespace-nowrap leading-none">Thinking...</span>
    </span>
  );
};
